import { AutocompleteTextField } from "@dash/form";
import type { Interpolation, Theme } from "@emotion/react";
import type { FC } from "react";

import { useServiceClient } from "@megaron/react-clients";

import { SupportTicketLinkedInvoice } from "./SupportTicketLinkedInvoice";
import { SupportTicketLinkedOrder } from "./SupportTicketLinkedOrder";
import {
  fetchInvoiceNumberSuggestions,
  fetchOrderNumberSuggestions,
} from "./supportTicketInvoiceOrderDocSearch";
import { useSupportTicketInvoiceOrderSync } from "./useSupportTicketInvoiceOrderSync";

type Props = {
  invoiceNumber: string;
  orderNumber: string;
  onInvoiceNumberChange: (value: string) => void;
  onOrderNumberChange: (value: string) => void;
  onInvoiceBlur?: () => void;
  onOrderBlur?: () => void;
  isDisabled?: boolean;
  fieldClassName?: Interpolation<Theme>;
};

export const SupportTicketInvoiceOrderFields: FC<Props> = ({
  invoiceNumber,
  orderNumber,
  onInvoiceNumberChange,
  onOrderNumberChange,
  onInvoiceBlur,
  onOrderBlur,
  isDisabled = false,
  fieldClassName,
}) => {
  const docs = useServiceClient("docs");

  useSupportTicketInvoiceOrderSync({
    invoiceNumber,
    orderNumber,
    setInvoiceNumber: onInvoiceNumberChange,
    setOrderNumber: onOrderNumberChange,
  });

  return (
    <>
      <AutocompleteTextField
        label="Numer faktury"
        value={invoiceNumber}
        onChange={onInvoiceNumberChange}
        isDisabled={isDisabled}
        css={fieldClassName}
        keyName="support-invoice-number"
        getOptions={(searchText) => fetchInvoiceNumberSuggestions(docs, searchText)}
        inputElementProps={{
          onBlur: onInvoiceBlur,
          onKeyDown: (event) => {
            if (event.key === "Enter") {
              event.currentTarget.blur();
            }
          },
        }}
      />
      <SupportTicketLinkedInvoice invoiceNumber={invoiceNumber} orderNumber={orderNumber} />
      <AutocompleteTextField
        label="Numer zamówienia"
        value={orderNumber}
        onChange={onOrderNumberChange}
        isDisabled={isDisabled}
        css={fieldClassName}
        keyName="support-order-number"
        getOptions={(searchText) => fetchOrderNumberSuggestions(docs, searchText)}
        inputElementProps={{
          onBlur: onOrderBlur,
          onKeyDown: (event) => {
            if (event.key === "Enter") {
              event.currentTarget.blur();
            }
          },
        }}
      />
      <SupportTicketLinkedOrder orderNumber={orderNumber} />
    </>
  );
};
